import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignFormSubmissionsHandoff } from '@/pages/workspaces/automations/[campaignId]/form-submissions/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/form-submissions',
)({
  component: JourneysCampaignFormSubmissionsHandoff,
});
